import React, { useState, useEffect } from 'react';

const LandscapeAlert = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [userDismissed, setUserDismissed] = useState(false);

  // Detectar si es móvil y orientación portrait
  const checkOrientation = () => {
    const isMobile = 
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      window.matchMedia("(max-width: 768px)").matches;
      
    const isPortrait = window.innerHeight > window.innerWidth;
    
    // Solo mostrar si no ha sido descartado por el usuario
    setShowAlert(isMobile && isPortrait && !userDismissed);
  };

  useEffect(() => {
    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    return () => window.removeEventListener('resize', checkOrientation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDismissed]);

  const handleAccept = () => {
    setUserDismissed(true);
    setShowAlert(false);
  };

  if (!showAlert) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.dialog}>
        <h2 style={styles.title}>Best Viewing Experience Alert</h2>
        <p style={styles.text}>
          For the best experience, please rotate your device to landscape mode.
          This web application is optimized for wider screens and may not display
          correctly in portrait mode.
        </p>
        <button 
          onClick={handleAccept}
          style={styles.button}
          aria-label="Accept landscape recommendation"
        >
          Ok
        </button>
      </div>
    </div>
  );
};

// Estilos actualizados
const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    backdropFilter: 'blur(3px)',
  },
  dialog: {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '10px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    maxWidth: '90%',
    width: '400px',
    textAlign: 'center',
  },
  title: {
    color: '#2c3e50',
    marginBottom: '1rem',
    fontSize: '1.25rem',
  },
  text: {
    color: '#666',
    lineHeight: '1.5',
    marginBottom: '1.5rem',
  },
  button: {
    backgroundColor: '#3498db',
    color: 'white',
    border: 'none',
    padding: '0.75rem 1.5rem',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: 'background-color 0.3s ease',
  },
};

export default LandscapeAlert;